// Constantes globales du site — source unique de vérité pour l'entité "Tohu Bohu"
// utilisée à la fois par le rendu client (LegacyPage.jsx) et par les scripts de
// build (scripts/prerender.mjs, scripts/generate-sitemap.mjs, scripts/generate-llms.mjs).
//
// Domaine de production — irrigue automatiquement le canonical, le sitemap.xml,
// les balises Open Graph, le JSON-LD et le llms.txt.
export const SITE_URL = 'https://tohu-ai.com';

export const SITE_NAME = 'Tohu Bohu';
export const SITE_LOCALE = 'fr_FR';
export const SITE_LANG = 'fr';

export const SITE_TAGLINE = "Le système d'exploitation de vos relations B2B.";

// Description "entité" canonique — doit rester identique partout (index.html,
// JSON-LD Organization, llms.txt) pour renforcer le signal d'entité en GEO.
export const SITE_ENTITY_DESCRIPTION =
  "Tohu Bohu est l'OS Relationnel : une plateforme d'intelligence relationnelle B2B qui transforme les interactions commerciales (emails, réunions, CRM, LinkedIn) en signaux exploitables — score relationnel, mémoire relationnelle, brief IA — pour les équipes vente, business development et management.";

// ⚠️ DÉCISION PRODUIT REQUISE — IMAGE OPEN GRAPH
// Aucune image dédiée (1200×630) n'existe dans public/assets/. Tant qu'aucune image
// de marque n'est fournie, og:image / twitter:image sont omis plutôt que de pointer
// vers un fichier inexistant (ce qui casserait les aperçus au lieu de simplement les
// priver d'image). Dès qu'un visuel est disponible, déposez-le dans
// public/assets/images/og-cover.png (1200×630, <300KB) et renseignez la constante
// ci-dessous : toutes les pages en hériteront automatiquement.
export const DEFAULT_OG_IMAGE = null; // ex: '/assets/images/og-cover.png'

// Aucun compte X/Twitter identifié sur le site — laisser null tant qu'il n'est pas confirmé.
export const TWITTER_SITE_HANDLE = null;

// Liens d'entité (sameAs).
export const ORGANIZATION_SAME_AS = ['https://www.linkedin.com/in/jordan-tohu-586096412/'];

export const FOUNDERS = [
  { name: 'Maxime Weinstein', jobTitle: 'CEO & Co-fondateur' },
  { name: 'Jordan Chekroun', jobTitle: 'CTPO & Co-fondateur' },
];

export function absoluteUrl(path) {
  if (!path) return SITE_URL;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
